// Konfiguracja tabeli zadań dla dashboardu handlowca

import { IWiseTableColumn, IWiseTableParameter, IWiseTableAction } from 'components/wise';
import { ILoadDataParam } from 'plugins/api/types';
import React from 'react';
import { EditIcon } from 'assets/icons';

/**
 * Funkcja tworząca konfigurację parametrów (opcji nad tabelą)
 * @param t - funkcja tłumaczeń
 */
export const getTraderDashboardTasksTableParameters = (
  t: (key: string) => string
): IWiseTableParameter[] => {
  return [
    {
      type: 'search',
      label: t('Szukaj zadania'),
      field_symbol: 'search_keyword',
      default_value: ''
    }
  ];
};

/**
 * Funkcja tworząca konfigurację kolumn
 * @param t - funkcja tłumaczeń
 */
export const getTraderDashboardTasksTableColumns = (
  t: (key: string) => string
): IWiseTableColumn[] => {
  return [
    {
      type: 'icon',
      label: t('Ikona'),
      field_symbol: 'icon',
      align: 'center',
      tooltip: null,
      size: 60
    },
    {
      type: 'text',
      label: t('Nazwa zadania'),
      field_symbol: 'name',
      align: 'left',
      tooltip: null,
      size: 200
    },
    {
      type: 'avatar',
      label: t('Klient'),
      field_symbol: 'client_name',
      align: 'left',
      tooltip: null,
      size: 150
    },
    {
      type: 'date',
      label: t('Termin'),
      field_symbol: 'due_date',
      align: 'center',
      tooltip: null,
      size: 120,
      highlight_past_date: true
    },
    {
      type: 'priority',
      label: t('Priorytet'),
      field_symbol: 'priority',
      align: 'center',
      tooltip: null,
      size: 100
    }
  ];
};

/**
 * Funkcja tworząca konfigurację akcji
 * @param t - funkcja tłumaczeń
 */
export const getTraderDashboardTasksTableActions = (
  t: (key: string) => string
): IWiseTableAction[] => {
  return [
    {
      symbol: null,
      type: 'HEADER',
      label: t('Otwórz listę zadań'),
      style: null,
      method: 'Redirect',
      method_params: {
        command_url: '',
        page_url: '/trader/tasks',
        params_list: null
      },
      refresh_data_mode: 'NONE'
    },
    {
      symbol: null,
      type: 'NO_CONTEXT',
      label: t('Utwórz'),
      style: 'ACTION_PLUS',
      method: 'Redirect',
      method_params: {
        command_url: '',
        page_url: "/trader/tasks/new",
        params_list: ''
      },
      refresh_data_mode: 'ONSUCCESS'
    },
    {
      symbol: null,
      type: 'CONTEXT_MAIN',
      label: t('Edytuj'),
      style: 'ACTION_EDIT',
      customIcon: React.createElement(EditIcon),
      method: 'Redirect',
      method_params: {
        command_url: '',
        page_url: '/trader/tasks',
        params_list: 'id=:id',
        redirect_mode: 'path'
      },
      refresh_data_mode: 'ONSUCCESS'
    }
  ];
};

/**
 * Parametry do pobierania danych
 * Mockowany endpoint - będzie zwracał dane z JSON
 */
export const traderDashboardTasksTableLoadDataParams: ILoadDataParam = {
  get_url: '/sales-crm/tasks',
  params_list: null
};
